import { FoodRequestOptions } from './food-request-options';

export class ProductFilter extends FoodRequestOptions {
    Id_CategoryProduct: number;
    CategoryName: string;
    WordFiltr: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/product-filter-model.ts